import { render, staticRenderFns } from "./IndexSenior.vue?vue&type=template&id=3afec212&scoped=true&"
import script from "./IndexSenior.vue?vue&type=script&lang=js&"
export * from "./IndexSenior.vue?vue&type=script&lang=js&"
import style0 from "./IndexSenior.vue?vue&type=style&index=0&id=3afec212&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afec212",
  null
  
)

export default component.exports